import React, { useEffect, useState, useRef } from 'react';
import {
  get_shift,
  bp_machine_data,
  get_employee,
  add_machine_shift,
  get_machine_shift,
  Add_Bulk_Machine_Shift,
} from '../../../utils/api';
import { toast } from 'react-toastify';
import { Table, Modal, Card } from 'antd';
import { accessControlUtils } from '@/components/AccessControlUtils';
import { useSelector } from 'react-redux';
import ReusableSearchInput from '@/components/ReusableSearch';
import { useTranslation } from 'react-i18next';
import { defaultColors } from '@/themes/antd-theme';
import Icons from '@/components/third-party/Icons';
import { useTheme } from '@/App';
import { Typography } from 'antd';

const { Title } = Typography;

function Shift() {
  const { isDark } = useTheme();
  const textColor = isDark ? '#ffffff' : '#1f2937';
  const inputRef = useRef(null);
  const [machine_shift_details, set_machine_shift_details] = useState([]);
  const [shift_data, set_shift_data] = useState([]);
  const [machine_data, set_machine_data] = useState([]);
  const [employee_data, set_employee_data] = useState([]);
  const [shift_submit_data, set_shift_submit_data] = useState([]);
  const { t } = useTranslation();
  const [shift_obj, set_shift_obj] = useState({
    shift: '',
    shift_id: '',
    machine: '',
    machine_id: '',
    employee_names: [],
    employee: [],
  });
  const [searchvalue, setSearchvalue] = useState('');
  const selectedModule = useSelector((state) => state.moduleView);
  const machine_shift_columns = [
    {
      dataIndex: 'shift',
      title: 'Shift',
      key: 'shift',
      width: '8%',
    },
    // {
    //   dataIndex: "machine",
    //   title: "Machine",
    //   key: "machine",
    //   width: "8%",
    // },
    {
      dataIndex: 'employee_names',
      title: 'Employees',
      key: 'employee',
      width: '8%',
      render: (employee_names) => employee_names?.join(', '),
    },
  ]?.filter(Boolean);

  //####################### Handle Api's######################################################

  const get_all_inventory = async () => {
    try {
      await get_shift(success_get_shift);
      await bp_machine_data(success_machine_list_get);
      await get_employee(success_set_employee_list);
      await get_machine_shift(success_get_machine_shift);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  const success_get_shift = (res) => {
    set_shift_data(res?.data?.data);
  };
  const success_machine_list_get = (res) => {
    set_machine_data(res?.data?.data);
  };
  const success_set_employee_list = (res) => {
    set_employee_data(res?.data?.data);
  };
  const success_get_machine_shift = (res) => {
    set_machine_shift_details(res?.data?.data);
  };

  //Add inventory
  const submit_shift = async () => {
    try {
      await add_machine_shift({ data_flow: shift_submit_data }, success_add_shift);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const success_add_shift = (res) => {
    if (res.status === 'failed') {
      toast.warning(res.message);
    } else {
      set_shift_submit_data([]);
      if (inputRef.current) {
        inputRef.current.value = '';
      }
      if (res?.existing?.length > 0) {
        error(res?.existing);
      }
      get_machine_shift(success_get_machine_shift);
      toast.success('Users shift added successfully');
    }
  };

  const reset_function = () => {
    set_shift_obj({
      shift: '',
      shift_id: '',
      machine: '',
      machine_id: '',
      employee_names: [],
      employee: [],
    });
  };

  const error = (exists_data) => {
    Modal.error({
      title: 'Error Message',
      content: (
        <Table
          size="small"
          bordered
          columns={[
            {
              dataIndex: 'name',
              align: 'center',
              title: 'Name',
            },
            {
              dataIndex: 'msg',
              title: 'Error Message',
            },
          ]}
          pagination={{ pageSize: 10 }}
          dataSource={exists_data}
        />
      ),
      width: '40%',
      okText: 'Close',
    });
  };

  useEffect(() => {
    get_all_inventory();
  }, []);

  return (
    <Card
      className="m-2.5 border border-gray-300 shadow-md"
      title={
        <div className="flex items-center gap-2">
          <Icons.Clock className="text-blue-600" size={24} />
          <Title level={4} style={{ color: textColor, margin: 0, padding: 0 }}>
            {t('Shift Details')}
          </Title>
        </div>
      }
      extra={
        <ReusableSearchInput
          placeholder="Search here..."
          width={250}
          onSearch={(value) => setSearchvalue(value)}
          onChange={(e) => setSearchvalue(e.target.value)}
        />
      }
    >
      <Table
        dataSource={machine_shift_details}
        columns={[
          {
            dataIndex: 'shift',
            title: 'Shift',
            key: 'shift',
            align: 'center',
            width: '30%',
            filteredValue: [searchvalue],
            onFilter: (value, record) => {
              return String(record.shift)?.toLowerCase()?.includes(value.toLowerCase());
            },
          },
          // {
          //   dataIndex: "machine",
          //   title: "Machine",
          //   key: "machine",
          //   align: "center",
          //   width: "30%",
          // },
          {
            dataIndex: 'employees',
            title: 'Employees',
            key: 'employees',
            align: 'center',
            width: '40%',
            render: (employees) => employees?.join(', '),
          },
        ]?.filter(Boolean)}
        bordered
        pagination={{ pageSize: 10 }}
      />
    </Card>
  );
}

export default Shift;
